import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ExplorerPage from "./pages/ExplorerPage";
import CompanyProfilePage from "./pages/CompanyProfilePage";
import SelectedRecordsPage from "./pages/SelectedRecordsPage";
import AboutUsPage from "./pages/AboutUsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ExplorerPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/company/:companyId" element={<CompanyProfilePage />} />
          <Route path="/company/:companyId/selected-records" element={<SelectedRecordsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
